import { useState } from 'react';
import type { SubjectTaskDatabase } from '../../../../../types';

export type UseTaskMenuActionsProps = {
  task: SubjectTaskDatabase;
  onEdit: () => void;
  onDelete: () => void | Promise<unknown>;
};

export function useTaskMenuActions(props: UseTaskMenuActionsProps) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  function handleEditClick() {
    props.onEdit();
  }

  function handleDeleteClick() {
    setIsDeleteModalOpen(true);
  }

  function handleDeleteModalClose() {
    setIsDeleteModalOpen(false);
  }

  async function handleConfirmDelete() {
    await props.onDelete();
    setIsDeleteModalOpen(false);
  }

  return {
    isDeleteModalOpen,
    handleEditClick,
    handleDeleteClick,
    handleDeleteModalClose,
    handleConfirmDelete,
  };
}
